import { action } from 'typesafe-actions'
import { FeedbackActionTypes } from './types'
import { IUserCourse } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(FeedbackActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IUserCourse[]) => action(FeedbackActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(FeedbackActionTypes.LIST_ERROR, errors)
export const listClear = () => action(FeedbackActionTypes.LIST_CLEAR)

// Search Request
export const downloadRequest = (searchParams:any) => action(FeedbackActionTypes.DOWNLOAD_REQUEST, searchParams)
export const downloadSuccess = (url: string) => action(FeedbackActionTypes.DOWNLOAD_SUCCESS, url)
export const downloadError = (errors: any) => action(FeedbackActionTypes.DOWNLOAD_ERROR, errors)

// Select Data
export const selectData = (id: string) => action(FeedbackActionTypes.SELECT, id)
export const selectedData = () => action(FeedbackActionTypes.SELECTED)
export const selectedClear = () => action(FeedbackActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IUserCourse) => action(FeedbackActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IUserCourse) => action(FeedbackActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(FeedbackActionTypes.CREATE_ERROR, errors)

// Read
export const readRequest = (data: IUserCourse) => action(FeedbackActionTypes.READ_REQUEST, data)
export const readSuccess = (data: IUserCourse) => action(FeedbackActionTypes.READ_SUCCESS, data)
export const readError = (errors: any) => action(FeedbackActionTypes.READ_ERROR, errors)

// Update
export const updateRequest = (keyValues: any) => action(FeedbackActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IUserCourse) => action(FeedbackActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(FeedbackActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IUserCourse) => action(FeedbackActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(FeedbackActionTypes.DELETE_SUCCESS, id)  // Return deleted User id to remove from state
export const deleteError = (errors: any) => action(FeedbackActionTypes.DELETE_ERROR, errors)
